import { createContext, useContext } from "react";

export const ProtectedContext = createContext<boolean>(false);

export const ProtectedProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <ProtectedContext.Provider value={true}>
      {children}
    </ProtectedContext.Provider>
  );
};

export const useProtected = () => useContext(ProtectedContext);
